<template>
  <div class="expert-stats-dashboard">
    <a-spin :spinning="loading" tip="数据加载中..." size="large">
      <!-- 顶部标题栏 -->
      <header class="dashboard-header">
        <div class="header-content">
          <h1 class="page-title">专家数据统计</h1>
          <p class="page-subtitle">Expert Statistics Dashboard</p>
        </div>
      </header>

    <!-- 关键指标卡片 -->
    <section class="metrics-section">
      <div class="metric-card">
        <div class="metric-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
        <div class="metric-content">
          <div class="metric-label">专家总数</div>
          <div class="metric-value">{{ totalExperts }}</div>
          <div class="metric-desc">在库专家</div>
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="5" r="3"></circle>
            <line x1="12" y1="8" x2="12" y2="21"></line>
            <line x1="8" y1="13" x2="16" y2="13"></line>
          </svg>
        </div>
        <div class="metric-content">
          <div class="metric-label">男性专家</div>
          <div class="metric-value">{{ maleExperts }}</div>
          <div class="metric-desc">占比 {{ malePercent }}%</div>
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="5" r="3"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
            <path d="M8 17v4"></path>
            <path d="M16 17v4"></path>
            <line x1="12" y1="12" x2="12" y2="17"></line>
          </svg>
        </div>
        <div class="metric-content">
          <div class="metric-label">女性专家</div>
          <div class="metric-value">{{ femaleExperts }}</div>
          <div class="metric-desc">占比 {{ femalePercent }}%</div>
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 21h18"></path>
            <rect x="5" y="7" width="4" height="14"></rect>
            <rect x="15" y="7" width="4" height="14"></rect>
            <path d="M3 7h18"></path>
            <path d="M5 7V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2"></path>
          </svg>
        </div>
        <div class="metric-content">
          <div class="metric-label">高层次人才</div>
          <div class="metric-value">{{ governmentFinanceExperts }}</div>
          <div class="metric-desc">国家库、省库专家</div>
        </div>
      </div>
    </section>

    <!-- 主要图表区 -->
    <section class="charts-section">
      <div class="chart-card">
        <div class="card-header">
          <h3 class="card-title">专家年龄分布</h3>
        </div>
        <div class="card-body">
          <multi-barchart id="ageBarChart" ref="ageBarChartChartRef"
                          style="width: 100%;height: 400px"/>
        </div>
      </div>

      <div class="chart-card">
        <div class="card-header">
          <h3 class="card-title">专业品目排行</h3>
        </div>
        <div class="card-body">
          <multi-barchart id="topTenItemBarChart" ref="topTenItemBarChartRef"
                          style="width: 100%;height: 400px"/>
        </div>
      </div>
    </section>

    <!-- 饼图统计区 -->
    <section class="bottom-section">
      <div class="bottom-card">
        <div class="card-header">
          <h3 class="card-title">性别比例</h3>
        </div>
        <div class="card-body">
          <e-char-pie-chart id="sexPieChart" ref="sexPieChartRef"
                            style="width: 100%;height: 360px"/>
        </div>
      </div>

      <div class="bottom-card">
        <div class="card-header">
          <h3 class="card-title">在职状态</h3>
        </div>
        <div class="card-body">
          <e-char-pie-chart id="jobPieChart" ref="jobPieChartRef"
                            style="width: 100%;height: 360px"/>
        </div>
      </div>
    </section>

    <!-- 底部图表区 -->
    <section class="bottom-section">
      <div class="bottom-card">
        <div class="card-header">
          <h3 class="card-title">学历分布</h3>
        </div>
        <div class="card-body">
          <e-char-pie-chart id="educationalPieChart" ref="educationalPieChartRef"
                            style="width: 100%;height: 360px"/>
        </div>
      </div>

      <div class="bottom-card">
        <div class="card-header">
          <h3 class="card-title">地域分布</h3>
        </div>
        <div class="card-body">
          <e-char-pie-chart id="addressPieChart" ref="addressPieChartRef"
                            style="width: 100%;height: 360px"/>
        </div>
      </div>

      <div class="bottom-card">
        <div class="card-header">
          <h3 class="card-title">专家库级别分布</h3>
        </div>
        <div class="card-body">
          <e-char-pie-chart id="expertBankPieChart" ref="expertBankPieChartRef"
                            style="width: 100%;height: 360px"/>
        </div>
      </div>

      <div class="bottom-card">
        <div class="card-header">
          <h3 class="card-title">职称水平分布</h3>
        </div>
        <div class="card-body">
          <e-char-pie-chart id="professionalTitlePieChart" ref="professionalTitlePieChartRef"
                            style="width: 100%;height: 360px"/>
        </div>
      </div>
    </section>
    </a-spin>
  </div>
</template>

<script>

import ECharPieChart from '@/epp/statistics/Piechart.vue'
import MultiBarchart from '@/epp/statistics/MultiBarchart.vue'
import { GetExpertStatistic } from '@/epp/statistics/api/StatisticsRequest'
import { getCommonBarData, getCommonPieData } from '@/epp/statistics/util/StatisticsUtil'

export default {
  name: 'ExpertStatisticsIndex',
  components: {
    MultiBarchart,
    ECharPieChart,
  },
  data () {
    return {
      // 加载状态
      loading: false,
      // 顶部指标数据
      totalExperts: 0,
      maleExperts: 0,
      femaleExperts: 0,
      governmentFinanceExperts: 0, // 省政府和财政部专家
      malePercent: 0,
      femalePercent: 0,
    }
  },
  created () {
    this.getExpertStatistic()
  },
  watch: {},
  methods: {
    //获取全部的统计数据
    async getExpertStatistic () {
      try {
        // 开始加载
        this.loading = true

        let res = await GetExpertStatistic()
        if (200 !== res.code) {
          this.$message.error('获取专家统计信息失败')
          return
        }

        // 计算顶部指标数据
        this.calculateMetrics(res.result)

        // 初始化所有图表
        this.initSexPieChart(res.result.expertSexStatistic)
        this.initJobPieChart(res.result.expertJobStatistic)
        this.initEducationalPieChart(res.result.expertEducationStatistic)
        this.initAddressPieChart(res.result.expertAddressStatistic)
        this.initAgeBarChart(res.result.expertAgeStatistic)
        this.initTopTenItemBarChart(res.result.expertTopTenItemStatistic)
        this.initExpertBankPieChart(res.result.expertBankStatistic)
        this.initProfessionalTitlePieChart(res.result.expertProfessionalTitleStatistic)
      } catch (e) {
        this.$error({
          message: e.message || '获取专家统计信息失败',
        })
      } finally {
        // 结束加载
        this.loading = false
      }
    },
    // 计算顶部指标数据 - 从原始数据结构中计算
    calculateMetrics (data) {
      // 从性别统计中提取数据（使用原始字段名）
      if (data.expertSexStatistic && Array.isArray(data.expertSexStatistic)) {
        data.expertSexStatistic.forEach(item => {
          // 原始数据字段: statisticalName, count
          const name = item.statisticalName || ''
          const value = item.count || 0

          if (name.includes('男')) {
            this.maleExperts = value
          } else if (name.includes('女')) {
            this.femaleExperts = value
          }
        })

        // 计算总数和百分比
        this.totalExperts = this.maleExperts + this.femaleExperts

        if (this.totalExperts > 0) {
          this.malePercent = ((this.maleExperts / this.totalExperts) * 100).toFixed(1)
          this.femalePercent = ((this.femaleExperts / this.totalExperts) * 100).toFixed(1)
        }
      }

      // 从专家库统计中提取省政府和财政部专家数据（使用原始字段名）
      if (data.expertBankStatistic && Array.isArray(data.expertBankStatistic)) {
        let otherExperts = 0 // 其他专家
        data.expertBankStatistic.forEach(item => {
          const name = item.statisticalName || ''
          const value = item.count || 0
          // 查找包含"其他"的项
          if (name.includes('其他')) {
            otherExperts = value
          }
        })
        // 计算省政府和财政部专家总数
        this.governmentFinanceExperts = this.totalExperts - otherExperts
      }
    },
    //初始化专家性别饼图
    initSexPieChart (expertSexStatistic) {
      let series = {
        radius: ['0', '70%'],
        data: getCommonPieData(expertSexStatistic),
        // 饼图内部标签
        // label: {
        //   position: 'inner',
        //   fontSize: 14,
        // },
        labelLine: {
          show: true
        },
      }
      this.$nextTick(() => {
        this.$refs.sexPieChartRef.refreshData(series, '专家性别', '')
      })
    },
    //初始化专家在职/退休饼图
    initJobPieChart (expertJobStatistic) {
      //构造数据
      let series = {
        radius: ['0', '70%'],
        color: ['#21d7d1', '#5878e0'],
        data: getCommonPieData(expertJobStatistic),
        // 饼图内部标签
        labelLine: {
          show: true
        },
        // label: {
        //   position: 'inner',
        //   fontSize: 14,
        // },
      }
      this.$nextTick(() => {
        this.$refs.jobPieChartRef.refreshData(series, '专家在职/退休')
      })
    },
    //初始化专家学历玫瑰图
    initEducationalPieChart (expertEducationStatistic) {
      let series = {
        radius: ['20%', '70%'],
        data: getCommonPieData(expertEducationStatistic),
        //是否显示线
        labelLine: {
          show: true
        },
      }
      this.$nextTick(() => {
        this.$refs.educationalPieChartRef.refreshData(series, '专家学历', { bottom: '1%', })
      })
    },
    //初始化专家区域玫瑰图
    initAddressPieChart (expertAddressStatistic) {
      let series = {
        radius: ['20%', '70%'],
        //随机20种饼图颜色
        color: [
          '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEEAD',
          '#D4A5A5', '#774F38', '#E08E79', '#F1D4AF', '#ECE5CE',
          '#838689', '#C5E0DC', '#E8DDCB', '#CDB599', '#7FDBDA',
          '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77'
        ],
        data: getCommonPieData(expertAddressStatistic),
        //是否显示线
        labelLine: {
          show: true
        },
      }
      this.$nextTick(() => {
        this.$refs.addressPieChartRef.refreshData(series, '专家区域', { bottom: '1%', })
      })
    },
    //初始化年龄柱状图
    initAgeBarChart (expertAgeStatistic) {
      let data = getCommonBarData(expertAgeStatistic)
      let series = [{
        color: '#2f89cf',
        data: data.seriesData,
        tooltip: {
          valueFormatter: function (value) {
            return value + ' (人)'
          }
        },
      }]
      let xAxis = [{
        boundaryGap: true,
        axisLabel: { rotate: 30 },
        data: data.xAxisData,
      }]
      let yAxis = [{
        name: '专家人数',
      }]
      this.$nextTick(() => {
        this.$refs.ageBarChartChartRef.refreshData(series, xAxis, yAxis, '专家年龄')
      })
    },
    //初始化前十品目柱状图
    initTopTenItemBarChart (expertTopTenItemStatistic) {
      let data = getCommonBarData(expertTopTenItemStatistic)
      let series = [{
        color: '#54a22d',
        data: data.seriesData,
        tooltip: {
          valueFormatter: function (value) {
            return value + ' (人)'
          }
        },
      }]
      let xAxis = [{
        boundaryGap: true,
        axisLabel: { rotate: 30 },
        data: data.xAxisData,
      }]
      let yAxis = [{
        name: '专家人数',
      }]
      this.$nextTick(() => {
        this.$refs.topTenItemBarChartRef.refreshData(series, xAxis, yAxis, '专家前十品目')
      })
    },
    //初始化职称水平饼图
    initProfessionalTitlePieChart (expertProfessionalTitleStatistic) {
      let series = {
        radius: ['0', '70%'],
        color: ['#21d7d1', '#5878e0', '#54a22d', '#a0d20a'],
        data: getCommonPieData(expertProfessionalTitleStatistic),
      }
      this.$nextTick(() => {
        this.$refs.professionalTitlePieChartRef.refreshData(series, '专家职称水平', '')
      })
    },
    //初始化国家/省库饼图
    initExpertBankPieChart (expertBankStatistic) {
      let series = {
        radius: ['0', '70%'],
        data: getCommonPieData(expertBankStatistic),
      }
      this.$nextTick(() => {
        this.$refs.expertBankPieChartRef.refreshData(series, '国家/省库专家', '')
      })
    },
  }
}
</script>

<style scoped lang="less">
.expert-stats-dashboard {
  min-height: calc(100vh - 120px);
  background: #1a1d2d;
  padding: 32px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

// ===== 顶部标题栏 =====
.dashboard-header {
  margin-bottom: 32px;
  padding: 28px 32px;
  background: #242838;
  border-radius: 8px;
  border: 1px solid #334155;
}

.header-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
}

.page-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #f1f5f9;
  letter-spacing: 0.5px;
}

.page-subtitle {
  margin: 0;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
}

// ===== 关键指标卡片 =====
.metrics-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 32px;
}

.metric-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 28px 24px;
  background: #242838;
  border-radius: 8px;
  border: 1px solid #334155;
  transition: all 0.2s ease;
  position: relative;

  // 顶部彩色边框
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: #00ff41;
  }

  &:nth-child(2)::before {
    background: #00d9ff;
  }

  &:nth-child(3)::before {
    background: #ff6b35;
  }

  &:nth-child(4)::before {
    background: #ffcc00;
  }

  &:hover {
    border-color: #475569;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
}

.metric-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 255, 65, 0.1);
  border-radius: 8px;
  color: #00ff41;
  flex-shrink: 0;

  svg {
    width: 30px;
    height: 30px;
  }

  // 为不同卡片设置不同的图标颜色
  .metric-card:nth-child(2) & {
    background: rgba(0, 217, 255, 0.1);
    color: #00d9ff;
  }

  .metric-card:nth-child(3) & {
    background: rgba(255, 107, 53, 0.1);
    color: #ff6b35;
  }

  .metric-card:nth-child(4) & {
    background: rgba(255, 204, 0, 0.1);
    color: #ffcc00;
  }
}

.metric-content {
  flex: 1;
  min-width: 0;
}

.metric-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metric-value {
  font-size: 36px;
  font-weight: 800;
  color: #f1f5f9;
  line-height: 1;
  margin-bottom: 6px;
  font-family: 'SF Mono', 'Monaco', 'Courier New', monospace;
  letter-spacing: -0.5px;
}

.metric-desc {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

// ===== 图表卡片 =====
.charts-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 32px;
}

.chart-card {
  background: #242838;
  border-radius: 8px;
  border: 1px solid #334155;
  overflow: hidden;
  transition: all 0.2s ease;

  &:hover {
    border-color: #475569;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
}

.card-header {
  padding: 20px 24px;
  background: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid #334155;
}

.card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #f1f5f9;
  letter-spacing: 0.3px;
}

.card-body {
  padding: 24px;
  background: rgba(0, 0, 0, 0.1);
}

// ===== 饼图卡片 =====
.pie-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 32px;
}

.pie-card {
  background: #242838;
  border-radius: 8px;
  border: 1px solid #334155;
  overflow: hidden;
  transition: all 0.2s ease;

  &:hover {
    border-color: #475569;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
}

.pie-header {
  padding: 16px 20px;
  background: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid #334155;
}

.pie-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #f1f5f9;
  letter-spacing: 0.3px;
}

.pie-body {
  padding: 20px;
  background: rgba(0, 0, 0, 0.1);
}

// ===== 底部图表 =====
.bottom-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.bottom-card {
  background: #242838;
  border-radius: 8px;
  border: 1px solid #334155;
  overflow: hidden;
  transition: all 0.2s ease;

  &:hover {
    border-color: #475569;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
}

// ===== 响应式设计 =====
@media (max-width: 1400px) {
  .metrics-section {
    grid-template-columns: repeat(2, 1fr);
  }

  .pie-section {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .charts-section {
    grid-template-columns: 1fr;
  }

  .bottom-section {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .expert-stats-dashboard {
    padding: 16px;
  }

  .dashboard-header {
    padding: 20px;
    margin-bottom: 24px;
  }

  .page-title {
    font-size: 22px;
  }

  .metrics-section {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .pie-section {
    grid-template-columns: 1fr;
  }

  .metric-value {
    font-size: 32px;
  }

  .metric-card {
    padding: 24px 20px;
  }
}

// ===== 滚动条样式 =====
::v-deep ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::v-deep ::-webkit-scrollbar-track {
  background: #0f1219;
  border-radius: 4px;
}

::v-deep ::-webkit-scrollbar-thumb {
  background: #334155;
  border-radius: 4px;
  transition: background 0.2s ease;

  &:hover {
    background: #475569;
  }
}

// ECharts z-index 提升
::v-deep .echarts-tooltip {
  z-index: 9999 !important;
}

::v-deep .echarts-legend {
  z-index: 100 !important;
}
</style>
